import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/src/locale/pt";

Vue.use(Vuetify, {
    iconfont: "mdi", // 'md' || 'mdi' || 'fa' || 'fa4'
});

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: "#4caf50",
                secondary: "#3f51b5",
                accent: "#607d8b",
                error: "#f44336",
                warning: "#ff9800",
                info: "#2196f3",
                success: "#8bc34a",
            },
        },
    },
    lang: {
        locales: { pt },
        current: "pt",
    },
});
